import React, {useEffect, useRef, useState} from "react";
import Header from "./Header";
import {API_BASE_URL} from "./SignUp";
import axios from "axios";
import {Card, CardContent, CircularProgress, Container, useTheme} from "@mui/material";
import {useNavigate} from "react-router-dom";
import SearchEngines from "./SearchEngines";
import Typography from "@mui/material/Typography";
import ArrowForward from '@mui/icons-material/ArrowForward';
import {ArrowBack, ArrowForwardIos} from "@mui/icons-material";
import {Footer} from "./Footer";
import {MoveToTop} from "./MoveToTop";

// const linkColors = ['red', 'blue', 'green']; // 색상 배열

export type LinkCollection = {
    id: number;
    name: string;
    image: string | ArrayBuffer | null;
    links: Link[];
    writer: {
        accountId: string;
    }
    createdAt: string;
    updatedAt: string;
};

export type Link = {
    id: number;
    link: string;
    image: string | ArrayBuffer | null;
    name: string;
    ranking: number;
    viewCount: number;
    writer: {
        accountId: string;
    }
    createdAt: string;
    updatedAt: string;
};

export type Advertisement = {
    id: number;
    link: string;
    image: string | ArrayBuffer | null;
    writer: {
        accountId: string;
    }
    createdAt: string;
    updatedAt: string;
};

function ArrowForwardIcon(props: { style: { color: string; marginLeft: string } }) {
    return null;
}

const Home: React.FC = () => {
    // const scrollContainerRef = useRef(null);
    const theme = useTheme();
    const linkColors = [theme.palette.secondary.main, theme.palette.success.main, theme.palette.primary.main]; // 테마에서 색상 가져오기
    const navigate = useNavigate();

    const [linkCollections, setLinkCollections] = useState<LinkCollection[]>([]);
    const [loading, setLoading] = useState(true);

    const [topAdvertisements, setTopAdvertisements] = useState([]);
    const [sideAdvertisements, setSideAdvertisements] = useState([]);

    const [isMobile, setIsMobile] = useState(false);

    function fetchCollectionsWithLinks() {
        axios.get(`${API_BASE_URL}/link-collections`)
            .then(response => {
                setLinkCollections(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching the link-collections data:', error);
                setLoading(false);
            });
    }

    function fetchAdvertisements() {
        axios.get(`${API_BASE_URL}/advertisements`)
            .then(response => {
                // setAdvertisements(response.data);

                const allAnnouncements = response.data;

                // position이 'top'인 광고와 'side'인 광고를 나눠서 상태에 저장
                const topAdvertisements = allAnnouncements.filter((ad: { position: string; }) => ad.position === 'top');
                const sideAdvertisements = allAnnouncements.filter((ad: { position: string; }) => ad.position === 'side');

                // 상태에 저장 (필요한 대로 변경)
                setTopAdvertisements(topAdvertisements);
                setSideAdvertisements(sideAdvertisements);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching the link-collections data:', error);
                setLoading(false);
            });
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // 768px 이하를 모바일로 간주
    };

    useEffect(() => {
        // if (scrollContainerRef.current) {
        //     scrollContainerRef.current.scrollLeft = 0; // 기본 스크롤 위치를 맨 왼쪽으로 설정
        // }
        fetchCollectionsWithLinks();
        fetchAdvertisements();

        handleResize(); // 초기 체크
        window.addEventListener('resize', handleResize); // 리사이즈 이벤트 리스너 등록

        return () => {
            window.removeEventListener('resize', handleResize); // 리스너 정리
        };
    }, []);

    if (loading) {
        return (
            <Container style={{ textAlign: 'center', padding: '50px' }}>
                <CircularProgress />
            </Container>
        );
    }

    const updateViewCount = async (linkId: number) => {
        await fetch(`${API_BASE_URL}/links/${linkId}/view`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };

    const handleLinkClick = async (linkId: number, linkUrl: string) => {
        try {
            await updateViewCount(linkId);

            window.open(linkUrl, '_blank');
        } catch (error) {
            console.error('Error updating view count:', error);
        }
    };

    const getFormattedDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 월은 0부터 시작하므로 +1
        const date = today.getDate();
        const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
        const day = dayNames[today.getDay()]; // 요일 가져오기

        return `${year}년 ${month}월 ${date}일 [${day}]`;
    };

    const addBookmark = () => {
        alert("Ctrl+D 혹은 Command+D 를 눌러서 이 페이지를 즐겨찾기에 추가하세요.");
    };

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            }}>
                {!isMobile &&
                    <div style={{paddingLeft: '23%', paddingTop: '1rem', textAlign: 'left'}}>
                        <a href="#" onClick={addBookmark} style={{textDecoration: 'none', color: 'black'}}>즐겨찾기 추가</a>
                        <span style={{margin: '0 10px'}}>/</span>
                        <span>{getFormattedDate()}</span>
                    </div>
                }
                <Header/>

                {/*메뉴 네비게이션*/}
                <div style={{backgroundImage: 'url("/nav/nav-background.png")', padding: '10px', marginBottom: '1rem'}}>
                    <div
                        // ref={scrollContainerRef}
                        style={{
                            display: 'flex',
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            alignItems: 'center',
                            // justifyContent: 'center',
                            justifyContent: 'flex-start'
                    }}>
                        {linkCollections.map(collection => (
                            <div
                                key={collection.id}
                                style={{
                                    marginRight: '15px',
                                    cursor: 'pointer',
                                    backgroundSize: 'cover',
                                    width: '150px',
                                    height: '50px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    whiteSpace: 'nowrap',
                                }}
                                onClick={() => navigate(`/collection/${collection.id}`, {state: collection})}
                            >
                                <span style={{color: 'white', fontWeight: 'bold'}}>{collection.name}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/*서치엔진 상단 링크*/}
                <div className='advertisement-container' style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', marginBottom: '1rem', maxWidth: '1200px', margin: 'auto'}}>
                    {topAdvertisements.map((ad: Advertisement, index) => (
                        <div key={index} style={{display: 'inline-block', margin: '3px'}}>
                            <a href={ad.link} target="_blank" rel="noopener noreferrer">
                                <div
                                    className="ad-banner"
                                    style={{
                                        width: '288.5px',
                                        height: '78.39px',
                                        // backgroundColor: '#f0f0f0',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {ad.image ? (
                                        <img className='top-banner'
                                            src={`data:image/png;base64,${ad.image}`}
                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        '이미지 없음'
                                    )}
                                </div>
                            </a>
                        </div>
                    ))}
                </div>

                {/*서치 엔진*/}
                {!isMobile && <SearchEngines />}

                {/*컬렉션 링크*/}
                <div style={{display: 'flex', justifyContent: 'center', margin: '0 auto'}}>
                    {/* 왼쪽 이미지 공간 */}
                    {!isMobile &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            {sideAdvertisements
                                .filter((_, index) => index % 2 === 0) // 짝수 인덱스 필터링
                                .map((ad: Advertisement, index) => (
                                    <div key={index} style={{
                                        width: '150px',
                                        backgroundColor: '#f0f0f0',
                                        marginBottom: '10px',
                                        cursor: 'pointer'
                                    }}>
                                        <a href={ad.link} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={`data:image/png;base64,${ad.image}`}
                                                style={{
                                                    width: '150px',
                                                    height: '300px',
                                                    marginRight: '8px',
                                                }}
                                            />
                                        </a>
                                    </div>
                                ))}
                        </div>
                    }

                    <div className='card-container' style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', maxWidth: '1200px'}}>
                        {linkCollections.map((collection) => (
                            <Card className="responsive-card" style={{margin: '5px', width: '229px', height: '443px', padding: '0'}}>
                                <CardContent style={{height: '100%', padding: '0'}}>
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        onClick={() => {
                                            navigate(`/collection/${collection.id}`, {state: collection});
                                        }}
                                        style={{
                                            cursor: 'pointer',
                                            overflow: 'hidden',
                                            textOverflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            margin: '0px',
                                            padding: '10px',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '2px',
                                            display: 'flex', // Flexbox 사용
                                            alignItems: 'center', // 수직 정렬
                                            justifyContent: 'space-between' // 양쪽 끝에 정렬
                                        }}
                                    >
                                        <img
                                            src={`data:image/png;base64,${collection.image}`}
                                            style={{
                                                width: '30px',
                                                height: '30px',
                                                verticalAlign: 'middle'
                                            }}
                                        />
                                        <span
                                            className='responsive-collection-name'
                                            style={{
                                                paddingLeft: '5px',
                                                width: '70%',
                                                display: 'inline-block',
                                                verticalAlign: 'middle',
                                                fontSize: '25px',
                                                overflow: 'hidden', // 잘리는 부분은 숨김
                                                whiteSpace: 'nowrap', // 한 줄로 유지
                                                // textOverflow: 'ellipsis', // 잘린 부분에 ... 표시
                                        }}>{collection.name}</span>
                                        <ArrowForwardIos style={{color: 'black', verticalAlign: 'middle', marginLeft: '1rem'}}/>
                                    </Typography>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        height: 'calc(100% - 70px)',
                                        padding: '10px'
                                    }}>
                                        {collection.links.slice(0, 10).map((link, index) => (
                                            <Typography
                                                key={link.id}
                                                variant="body1"
                                                onClick={() => handleLinkClick(link.id, link.link)}
                                                style={{
                                                    cursor: 'pointer',
                                                    margin: 0,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    flex: 1 // 균등한 높이를 위해 flex 속성 사용
                                                }}
                                            >
                                                <img
                                                    src={`/link/crowns-v3/crown-${index + 1}.png`}
                                                    style={{
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        width: '20px',
                                                        height: '20px',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                                <span style={{color: index < 3 ? linkColors[index] : 'black'}}>
                                                    {link.name}
                                                </span>
                                            </Typography>
                                        ))}
                                        {/* 남은 공간은 빈 항목으로 채우기 */}
                                        {collection.links.length < 10 &&
                                            Array.from({length: 10 - collection.links.length}).map((_, index) => (
                                                <Typography key={`empty-${index}`} variant="body1"
                                                            style={{visibility: 'hidden', flex: 1}}>
                                                    &nbsp;
                                                </Typography>
                                            ))
                                        }
                                    </div>
                                </CardContent>
                            </Card>

                        ))}
                    </div>

                    {/*오른쪽 광고 공간*/}
                    {!isMobile &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            {sideAdvertisements
                                .filter((_, index) => index % 2 === 1) // 홀수 인덱스 필터링
                                .map((ad: Advertisement, index) => (
                                    <div key={index}
                                         style={{width: '150px', backgroundColor: '#f0f0f0', marginBottom: '10px'}}>
                                        <a href={ad.link} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={`data:image/png;base64,${ad.image}`}
                                                style={{
                                                    width: '150px',
                                                    height: '300px',
                                                    marginRight: '8px',
                                                }}
                                            />
                                        </a>
                                    </div>
                                ))}
                        </div>
                    }
                </div>

                <Footer/>
                <MoveToTop />
            </div>
        </>
    );
}

export default Home